"use client"

import type { Channel } from "@/config/channel"
import { AppChannel } from "@/config/channel"
import { useConfigParams } from "@/hooks/use-config-params"
import { cn } from "@/lib/cn"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { ComponentPropsWithRef } from "react"
import { Img } from "./image"

export function Checkbox({
  className,
  checked,
  ref,
  ...props
}: ComponentPropsWithRef<typeof CheckboxPrimitive.Root>) {
  const { channel } = useConfigParams()
  const vendor =
    typeof window !== "undefined" ? window.APP_VENDOR : process.env.APP_VENDOR

  type Icons = { on: string; off: string }

  const byVendor: Partial<Record<string, Icons>> = {
    snai: {
      on: "/assets/form/snai/checkbox-checked.svg",
      off: "/assets/form/snai/checkbox-unchecked.svg",
    },
    pokerstars: {
      on: "/assets/form/pokerstars/checkbox-checked.svg",
      off: "/assets/form/checkbox-unchecked.svg",
    },
  }

  const byChannel: Partial<Record<Channel, Icons>> = {
    [AppChannel.AppCasinoHub]: {
      on: "/assets/form/casino/checkbox-checked.svg",
      off: "/assets/form/checkbox-unchecked.svg",
    },
  }

  const DEFAULT: Icons = {
    on: "/assets/form/checkbox-checked.svg",
    off: "/assets/form/checkbox-unchecked.svg",
  }

  const icon =
    byVendor[vendor] ??
    (channel != null ? byChannel[channel] : undefined) ??
    DEFAULT

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn("size-6", className)}
      checked={checked}
      {...props}
    >
      <CheckboxPrimitive.Indicator forceMount className={cn("size-6")}>
        <Img
          alt="checkbox status icon"
          src={checked ? icon.on : icon.off}
          width={24}
          height={24}
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
